<template>
  <div v-if="scalePercentage && scalePercentageType">
    <template v-if="!fallback && !scalePercentageType.exclude">
      <ScalePercentageEdit :id="scalePercentage.id" />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="resetScalePercentage" v-on="on" small>Reset</v-btn>
        </template>
        <span>Forget this custom scale and track the base scale</span>
      </v-tooltip>
      <v-btn :to="{name:'scalePercentage',params:{id:scalePercentage.id}}" small>
        <v-icon>launch</v-icon>
        {{scalePercentageType.name}}
      </v-btn>
      <v-btn @click="showChart = true" v-if="!showChart" small>
        <v-icon>show_chart</v-icon>Show chart
      </v-btn>
      <div class="ajaxForm" v-if="showChart">
        <LineChart :value="dataCollection" />
        <a @click="showChart = false" v-if="showChart">Close chart</a>
      </div>
    </template>
    <template v-if="fallback">
      <span style="text-decoration:italic">fallback</span>
      <span v-if="scalePercentageType.exclude">: Automatically calculated</span>
      <ScaleLitePercentage :id="scalePercentage.id" />
      <v-tooltip bottom v-if="!scalePercentageType.exclude">
        <template v-slot:activator="{ on }">
          <v-btn @click="overrideScalePercentage" v-on="on" color="info" small>Override</v-btn>
        </template>
        <span>Stop tracking the base scale and use a custom scale</span>
      </v-tooltip>
      <v-btn :to="{name:'scalePercentage',params:{id:scalePercentage.id}}" small>
        <v-icon>launch</v-icon>
        {{scalePercentageType.name}}
      </v-btn>
    </template>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import LineChart from "@/components/quote/scales/LineChart";
import ScaleLitePercentage from "@/components/quote/scales/ScaleLitePercentage";
import ScalePercentageEdit from "@/components/quote/scales/ScalePercentageEdit";
export default {
  name: "ScalePercentage",
  props: ["value", "groupid", "promotionid", "scalePercentageTypesMap"],
  components: { LineChart, ScaleLitePercentage, ScalePercentageEdit },
  computed: {
    fallback() {
      return this.value.scalePercentage ? false : true;
    },
    scalePercentage() {
      return this.fallback
        ? this.value.scalePercentageFallback
        : this.value.scalePercentage;
    },
    scalePercentageType() {
      return this.scalePercentageTypesMap
        ? this.scalePercentageTypesMap[
            this.scalePercentage.scalepercentagetypeid
          ]
        : undefined;
    }
  },
  data() {
    return {
      dataCollection: null,
      showChart: false
    };
  },
  methods: {
    async fetchDataCollection() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/scalePercentages/${this.scalePercentage.id}/dataCollection`
      );
      // console.log(response.data);
      this.dataCollection = response.data;
    },
    async resetScalePercentage() {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/admin/sales/scalePercentages/${this.scalePercentage.id}/reset`,
          {
            params: { groupid: this.groupid, promotionid: this.promotionid }
          }
        );
        // console.log(response.data);
        this.$emit("updated");
      }
    },
    async overrideScalePercentage() {
      await nbmlaw.post(
        `/cors/admin/sales/scalePercentages/${this.scalePercentage.id}/override`,
        null,
        {
          params: { groupid: this.groupid, promotionid: this.promotionid }
        }
      );
      // console.log(response.data);
      this.$emit("updated");
    }
  },
  watch: {
    scalePercentage: {
      immediate: true,
      handler() {
        this.fetchDataCollection();
      }
    }
  }
};
</script>

<style></style>